import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { useDeviceType } from "../helper/useDeviceType";
import {
	ProductModalData,
	getProductBrands,
} from "../store/actions/productAction";
import {
	changeCampaignProductPage,
	getActivePromotionCampaign,
	getAllProductsSaleCampaign,
	minusHour,
	resetActivePromotionCampaign,
} from "../store/actions/promotionCampaignAction";
import CartPopUp from "../containers/Cart/CartPopUp";
import { Col, Row, Spinner } from "react-bootstrap";
import { useFavorites } from "../contexts/favorites/use-favorites";
import { useCart } from "../contexts/cart/use-cart";
import { initBasket } from "../store/actions/cartAction";
import {
	CampaignBanner,
	CampaignDescriptions,
	SaleCampaignBannerContainer,
	SaleCampaignPageContainer,
	SpinnerWrapper,
} from "../containers/SalePromotionCampaign/SaleCampaign.style";
import SaleCampaign from "../containers/SalePromotionCampaign/SaleCampaign";
import API from "../network/redAPI";
import t from "../i18n/translate";
import flashSaleLogo from "../assets/icons/flash-sale.png";
import blackFridayLogo from "../assets/icons/black-friday.png";
import ExpiredGif from "../assets/images/expired.gif";
import WaitingGif from "../assets/images/waiting.gif";
import NotFoundGif from "../assets/images/not-found.gif";
import SaleCampaignTimer from "../containers/SalePromotionCampaign/CampaignTimer";

const cartType = localStorage.getItem("expressMode") ? "express" : "normal";
const type = cartType === "express" ? 1 : 0;
const color = type === 1 ? "#f01266" : "#9cc54b";
const user = JSON.parse(localStorage.getItem("user"));

const FallbackWrapperStyle = {
	height: "100vh",
	display: "grid",
	placeItems: "center",
	background: "#fff",
};

function SaleCampaignPage(props, { userAgent }) {
	const deviceType = useDeviceType(userAgent);
	const ref = useRef(null);

	const { campaignId } = useParams();

	const [saleCampaign, setSaleCampaign] = useState(null);
	const [render, setRender] = useState(false);

	let limit = 20;

	const { fetchFavorites } = useFavorites();
	const { fetchOrderItems } = useCart();

	useEffect(() => {
    setRender(true);
		API.GetActiveSaleCampaign()
			.then((res) => res.json())
			.then((res) => {
				if (res.success) {
					if (
						new Date(
							minusHour(res.data?.sale_promotion_campaign_product?.start_date, 7)
						)?.getTime() < new Date()?.getTime()
					) {
						setSaleCampaign(res.data);
					} else {
						// window.location.href = type === 1 ? "/express" : "/";
					}
				} else {
					// window.location.href = type === 1 ? "/express" : "/";
				}
				let timeout = setTimeout(() => {
					setRender(false);
				}, 1000);
				return () => clearTimeout(timeout);
			});
	}, []);

	useEffect(() => {
		if (cartType === "express") {
			props.initBasket("express");
		}

		const body = {
			campaign_id: campaignId,
			limit: limit,
			page: props?.campaignProduct_page,
		};

		props.getAllProductsSaleCampaign(body);
		props.getActivePromotionCampaign();
		props.getProductBrands();
		if (user) {
			fetchOrderItems(cartType);
			fetchFavorites({ type });
		}
	}, []);

	const Loading = (position = null) => {
		return (
			<SpinnerWrapper style={{ position }}>
				<Spinner animation="grow" size="sm" style={{ color }} />
				<Spinner animation="grow" size="sm" style={{ color }} />
				<Spinner animation="grow" size="sm" style={{ color }} />
			</SpinnerWrapper>
		);
	};

	if (render) {
		return <div style={FallbackWrapperStyle}>{Loading("relative")}</div>;
	}

	if (!props.isLive) {
		return (
			<div style={FallbackWrapperStyle}>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: 10,
						alignItems: "center",
					}}
				>
					{props.isExpired && !props.isDisplay ? (
						<>
							<img src={ExpiredGif} alt="Expired" style={{ width: "18.75rem" }} />
							<p style={{ fontSize: "1.25rem", fontWeight: 600 }}>
								{t("promotion_campaign_expired_title")}!
							</p>
						</>
					) : props.isDisplay && !props.isExpired ? (
						<>
							<img src={WaitingGif} alt="Counting" style={{ width: "21.875rem" }} />
							<p style={{ fontSize: "1.25rem", fontWeight: 600 }}>
								{t("promotion_campaign_not_started_title")}!
							</p>
						</>
					) : (
						<>
							<img src={NotFoundGif} alt="NotFound" style={{ width: "21.875rem" }} />
							<p style={{ fontSize: "1.25rem", fontWeight: 600 }}>
								{t("promotion_campaign_not_found_title")}!
							</p>
						</>
					)}
				</div>
			</div>
		);
	}

	return (
		<>
			<SaleCampaignPageContainer ref={ref}>
				{/* {window.matchMedia("all and (max-width: 769px)").matches && (
					<Row className="m-0 p-0 bg-white mt-3">
						<Col xs={12}>
							<CampaignDescriptions style={{ background: "none", marginTop: 30 }}>
								<img
									src={
										saleCampaign
											? saleCampaign?.is_black_friday
												? blackFridayLogo
												: flashSaleLogo
											: null
									}
									alt={saleCampaign?.name}
									width={props.active_campaign?.is_black_friday ? 140 : 100}
									className="campaign-logo"
								/>
								<div className="count-down-content">
									<p className="campaign-promotion-end-in-label">
										{t("promotion_campaign_ends_in_title")}
									</p>
									<SaleCampaignTimer
										campaign={saleCampaign}
										resetCampaign={props.resetActivePromotionCampaign}
									/>
								</div>
							</CampaignDescriptions>
						</Col>
					</Row>
				)} */}
				<SaleCampaignBannerContainer style={{ height: "calc(100vh - 120px)" }}>
					<CampaignBanner>
						<img
							src={props.active_campaign?.banner?.web}
							alt={props.active_campaign?.name}
							className="campaign-banner-img"
						/>
					</CampaignBanner>
				</SaleCampaignBannerContainer>
				<Row className="m-0 pt-2 pb-3 pb-md-2 p bg-white border-bottom">
					<Col xs={12}>
						<CampaignDescriptions style={{ background: "none" }}>
							<img
								src={saleCampaign?.icon}
								alt={saleCampaign?.name}
								// width={props.active_campaign?.is_black_friday ? 140 : 100}
								className="campaign-logo main"
							/>
							<div className="count-down-content">
								<p className="campaign-promotion-end-in-label">
									{t("promotion_campaign_ends_in_title")}
								</p>
								<SaleCampaignTimer
									campaign={saleCampaign}
									resetCampaign={props.resetActivePromotionCampaign}
								/>
							</div>
						</CampaignDescriptions>
					</Col>
				</Row>
				<SaleCampaign
					props={props}
					saleCampaign={saleCampaign}
					cartType={cartType}
					type={type}
					color={color}
					limit={limit}
					loader={Loading}
				/>
			</SaleCampaignPageContainer>

			<CartPopUp deviceType={deviceType} />
		</>
	);
}

const mapStateToProps = (state) => ({
	brands: state.productReducer.brands,
	modalData: state.productReducer.modalData,
	cartType: state.cartReducer.cartType,
	loading: state.globalReducer.loading,
	active_campaign: state.promotionCampaignReducer.active_campaign,
	products: state.promotionCampaignReducer.products,
	total_items: state.promotionCampaignReducer.total_items,
	total_pages: state.promotionCampaignReducer.total_pages,
	page: state.promotionCampaignReducer.page,
	isExpired: state.promotionCampaignReducer.isExpired,
	isDisplay: state.promotionCampaignReducer.isDisplay,
	isLive: state.promotionCampaignReducer.isLive,
});

const mapDispatchToProps = (dispatch) => {
	return {
		getProductBrands: () => getProductBrands(dispatch),
		initBasket: (data) => initBasket(data, dispatch),
		ProductModalData: (data) => ProductModalData(data, dispatch),
		getActivePromotionCampaign: () => getActivePromotionCampaign(dispatch),
		resetActivePromotionCampaign: () => resetActivePromotionCampaign(dispatch),
		getAllProductsSaleCampaign: (data) =>
			getAllProductsSaleCampaign(data, dispatch),
		changeCampaignProductPage: (data) =>
			changeCampaignProductPage(data, dispatch),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SaleCampaignPage);
